(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:CommonsCtrl
     *
     * @description
     *
     */
    angular
        .module('commons')
        .controller('CommonsCtrl', CommonsCtrl);

    function CommonsCtrl(modalParams) {
        var vm = this;
        vm.model = {
            title : modalParams.title,
            message : modalParams.message
        }
    }
}());
